import { render, staticRenderFns } from "./Goodbye.vue?vue&type=template&id=67c60a4c&"
import script from "./Goodbye.vue?vue&type=script&lang=js&"
export * from "./Goodbye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports